import React, { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Link, redirect, useParams } from "react-router-dom";
import { Footer, Navbar } from "../adminComponents";
import axios from "axios";
import configData from "../config.json";
import {format} from "date-fns";
import { useNavigate } from "react-router-dom";

const FinishOrderlist=()=>{

    if (localStorage.getItem('eshopBranchID') === null || localStorage.getItem('eshopBranchID') === 'undefined') {
    window.location.replace('/adminLogin');
    }

    const [orders,setOrderList]=useState([]);
    const navigate=useNavigate();
    const [inputData,setInputData]=useState([]);   

    const handleInput=(e)=>{
    const {name,value}=e.target; 
    setInputData({...inputData,[name]:value});  
    }

    const handleSubmit=async(e)=>{
        e.preventDefault();  
        if (!inputData.dateFrom || !inputData.dateTo) {
            alert('Both dates are required.');
            return;
        }   
        if(inputData.dateFrom > inputData.dateTo){
            alert('Invalid Date Selection...');
            return;
        }   

        const payload = {
        ...inputData,
        branchID: localStorage.getItem('eshopBranchID')   
        };

        const response=await axios.post(configData.SERVER_ADMIN_URL+`/finishorderList`,payload)
            
        if(response.status===200){
            setOrderList(response.data);
        } 
        else{
            alert('System Error');
        } 
    }

    return(
        <>
        <Navbar/>
        <div className="container my-3 py-3">
            <h1 className="text-center">Finished Order List</h1>
            <div className="card">
                <div className="card-body">
                    <div className="col-lg-3">
                        <label>Date From</label>
                        <input type="date" className="form-control" name="dateFrom" id="dateFrom" 
                        onChange={(e) => handleInput(e)}></input>
                    </div>
                    <div className="col-lg-3">
                        <label>Date To</label>
                        <input type="date" className="form-control" name="dateTo" id="dateTo" 
                        onChange={(e) => handleInput(e)}></input>
                    </div>
                    <hr></hr>
                    <div className="col-lg-2">
                        <button type="button" class="btn btn-info">
                        <span class="glyphicon glyphicon-search" onClick={(e)=>{handleSubmit(e)}}>Search</span>
                        </button>
                    </div>
                </div>
            </div>

            {orders && orders.length>0 && (
            <div className="card text-justify">  
                <div className="card-header"></div>           
                    <div className="card-body">
                    <table className="table table-hover">
                        <thead>
                            <th>Sl.</th>
                            <th>Order To</th>
                            <th>Order Info</th>
                            <th>Customer Info</th>
                            <th>Delivery</th>
                        </thead>
                        <tbody>
                        {
                            orders && orders.length>0 && orders.map((order,index)=> 
                            <tr>
                                <td>{index+1}</td>
                                <td>{order.branchCode}</td>
                                <td>{'Order_ID: '+order.OrderID}<br></br>
                                {'Order_Date: '+format(order.OrderDate, 'dd/MM/yyyy')}<br></br>
                                <label style={{ fontWeight: 'bold' }}>{'Tracsaction_ID: '+order.TransactionID}</label><br></br>
                                <label style={{ fontWeight: 'bold' }}>{'Order_Amount : '+order.SubTotal.toLocaleString('en-IN')+' Tk.'}</label><br></br>
                                </td>
                                <td>
                                {'Customer: '+order.FullName}<br></br>
                                {'E-mail: '+order.Email}<br></br>
                                {'Contact No: '+order.Phone}<br></br>
                                {'Address: '+order.StreetAddress}<br></br>
                                {'Post Code : '+order.PostCode}<br></br> 
                                </td>
                                <td>
                                {'Mode of Payment : '+order.mop}<br></br>
                                {order.onlinePayment ?
                                    order.IsTransaction ?                                 
                                        <button className="w-20 btn btn-success " >Online Payment</button>
                                    :<div>
                                        <label style={{ color: 'green', fontWeight: 'bold', fontSize:'18px' }}>Paid</label><br></br>
                                        <a className="btn btn-info" href={order.VoucherLink}>download voucher</a>
                                    </div>
                                :<label style={{ color: 'green', fontWeight: 'bold', fontSize:'16px' }}>Please Contact With....  
                                    <a style={{ color: 'red', fontWeight: 'bold', fontSize:'18px' }}>{order.hotlineNo}</a></label>}
                                                                                    
                                </td>
                                {/* <td>{order.transportAddress}</td> */}
                                
                            </tr>
                         )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
            )}
        </div>
        <Footer/>
        </>
    ) 
}

export default FinishOrderlist;